export default __webpack_public_path__ + "static/media/03_statements.6b95c419.png";